import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class SalesAuditReportData extends ReportData<SalesAuditReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @field reportType: string = "SIMPLE";
}
